import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject){
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

const originalRepalce= Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject){
    return originalRepalce.call(this, location, onResolve, onReject)
  }
  return originalRepalce.call(this, location).catch(err => err)
}

Vue.use(Router);

export const constantRouterMap = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/home')
      },
      {
        path: '/us',
        name: 'us',
        component: () => import('@/views/us/us')
      }, {
        path: '/search',
        name: 'search',
        component: () => import('@/views/search/search')
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/login')
      },
      // {
      //   path: '/practices',
      //   name: 'practices',
      //   component: () => import('@/views/exam/practices')
      // },
      {
        path: '/exams',
        name: 'exams',
        component: () => import('@/views/exam/exams')
      },

      {
        path: '/exam-record/:type',
        name: 'examRecord',
        component: () => import('@/views/exam/examRecords')
      },
      {
        path: '/join-record',
        name: 'joinRecord',
        component: () => import('@/views/exam/joinRecord')
      },
      {
        path: '/wrong',
        name: 'wrongBook',
        component: () => import('@/views/exam/wrongBook')
      },{
        path: "/colExam/:answerid/:subjectid",
        name: "collect-exam",
        component: () => import ("@/views/exam/collectExam.vue")
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('@/views/exam/knowledge')
      },
      {
        path: '/practices',
        name: 'practices',
        component: () => import('@/views/exam/practices')
      },
      {
        path: '/courses/:id',
        name: 'courses',
        component: () => import('@/views/exam/courses')
      },
      {
        path: '/videos',
        name: 'videos',
        component: () => import('@/views/exam/videos')
      },
      {
        path: '/recommend/:id',
        name: 'recommend',
        component: () => import('@/views/exam/recomDetail')
      },
      {
        path: '/course-details',
        name: 'course-details',
        component: () => import('@/views/exam/courseDetails')
      },
      {
        path: "/photoDetail/:id",
        name: "photoDetail",
        meta: {
          authRequire: true,
        },
        component: () => import ("@/views/exam/photoDetail")
      },
      // {
      //   path: "/swiperDetail",
      //   name: "swiperDetail",
      //   component: () => import ("@/views/exam/swiperDetail.vue")
      // },
      {
        path: "/videoDetail/:id/:type",
        name: "videoDetail",
        meta: {
          authRequire: true,
        },
        component: () => import ("@/views/exam/videoDetail")
      },
      {
        path: '/course-section',
        name: 'course-section',
        component: () => import('@/views/exam/section')
      },
      {
        path: '/message',
        name: 'message',
        component: () => import('@/views/personal/message')
      },
      {
        path: '/league-info/:id',
        name: 'league-info',
        component: () => import('@/views/league/info.vue')
      },
      {
        path: '/league-apply/:id',
        name: 'league-apply',
        component: () => import('@/views/league/apply.vue')
      },
      {
        path: '/score/:id',
        name: 'league-score',
        component: () => import('@/views/league/score.vue')
      },
      {
        path: '/league-exam',
        name: 'leagueExam',
        component: () => import('@/views/league/exam.vue')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/personal/account')
      },
      {
        path: '/join/:examid',
        name: 'join',
        component: () => import('@/views/personal/join')
      },
      {
        path: '/password',
        name: 'password',
        component: () => import('@/views/personal/password')
      },
      {
        path: '/incorrect',
        name: 'incorrect',
        component: () => import('@/views/exam/incorrect')
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('@/views/personal/resetPassword')
      },
      {
        path:'/book-category',
        name:'book-category',
        component: ()=>import('@/views/book/category')
      },
      {
        path:'/book-detail/:id',
        name:'book-detail',
        component: ()=>import('@/views/book/detail')
      }
    ]
  },
  {
    path:'/book-read/:id/:page?',
    name:'book-read',
    component: ()=>import('@/views/book/read')
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import('@/views/mobile/Index')
  },
  {
    path: '/mobile-v2',
    name: 'MobileV2',
    component: () => import('@/views/mobileV2/Index')
  },
  {
    path: '/start/:id/:type?',
    name: 'start',
    component: () => import('@/views/exam/startExam')
  },
  {
    path: '*',
    redirect: '/home'
  }
]
export default new Router({
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      setTimeout(() => {
          window.scrollTo(savedPosition.x, savedPosition.y)
      }, 200)
    }else{
      setTimeout(() => {
        document.querySelector('.app-main').scrollTo(0,0)
      }, 200)
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js